/* eslint-disable camelcase */
/* eslint-disable array-callback-return */
import { useRef, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { Typography, Grid, Chip, Box, Paper, Button, Grow, TextField, InputAdornment } from "@mui/material";

import { useFlags } from "launchdarkly-react-client-sdk";

import ChipComp from "components/common/Chip";
import Filter from "components/Widgets/Filter";
import DataTable from "components/Widgets/DataTable";
import EditEmployee from "components/Widgets/Edit";
import DeleteEmployee from "components/Widgets/Delete";
import FileUpload from "components/Widgets/FileUpload";
import PageLoader from "components/common/PageLoader";
import CustomAvatar from "components/common/Avatar";

import { convertDate, getValue } from "components/Screens/CommonUtils";

import { ResetAddEmployee } from "store/actions/AddEmployee";
import { GetEmployeeDetails, ResetGetEmployeeDetails } from "store/actions/GetEmployeeDetails";
import { DeleteUser, ResetDeleteUser } from "store/actions/Settings/DeleteUser";
import { GetEmployeeList, ResetGetEmployeeList } from "store/actions/GetEmployeeList";
import { ResetEducationInfo } from "store/actions/Workforce/EmployeeDetils/EducationInfo";
import { GetCustomersList, ResetGetCustomersList } from "store/actions/Customers/GetCustomerList";
import { ResetAddEmployeeSalary } from "store/actions/Workforce/AddEmployee/AddEmployeeSalary";
import { ResetAddEmployeeSalaryData } from "store/actions/Workforce/AddEmployee/AddEmployeeSalaryData";
import { ResetemployeeSalaryInfo } from "store/actions/Workforce/EmployeeDetils/SalaryInfo";
import { ResetCalculateEmployeeSalary } from "store/actions/Workforce/AddEmployee/CalculateEmployeeSalary";

import { baseUrl } from "util/APIBaseUrl";
import getRequest from "util/APIHelperGet";
import { getFullMontDateYearFromDate, getChipProps } from "helpers";
import { UNDERSCORE_GLOBAL } from "constants/regexPatterns";

import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import totalEmployeesIcon from "components/Icons/TotalEmployeesIcon.png";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import CustomTooltip from "components/common/Tooltip";

import "./AdminWorkforce.scss";

let filterRemoved = false;

const styles = {
  position: "absolute",
  width: 300,
  top: 35,
  right: 0,
  left: -275,
  zIndex: 1,
  border: "1px light gray",
  p: 3,
  bgcolor: "background.paper",
};

const tableheadCellsRevamped = [
  {
    id: "First_Name",
    numeric: false,
    wrapCell: true,
    width: "21%",
    disablePadding: false,
    label: <Typography variant="h5">Employee</Typography>,
  },
  {
    id: "Country",
    sort: false,
    numeric: false,
    disablePadding: false,
    width: "11%",
    label: <Typography variant="h5">Country</Typography>,
  },
  {
    id: "Status",
    sort: false,
    numeric: false,
    disablePadding: false,
    width: "17%",
    label: <Typography variant="h5">Employement Status</Typography>,
  },
  {
    id: "Company",
    numeric: false,
    disablePadding: false,
    sort: false,
    width: "12%",
    label: <Typography variant="h5">Company</Typography>,
  },

  {
    id: "Joining_Date",
    sort: false,
    numeric: false,
    disablePadding: false,
    width: "15%",
    label: <Typography variant="h5">Joining Date</Typography>,
  },

  {
    id: "Employee_Status",
    sort: false,
    numeric: false,
    disablePadding: false,
    width: "17%",
    label: <Typography variant="h5">Employee Status</Typography>,
  },
  {
    id: "Payroll_Status",
    sort: false,
    numeric: false,
    width: "23%",
    disablePadding: false,
    label: <Typography variant="h5">Salary Details</Typography>,
  },
  {
    id: "action",
    label: <Typography variant="h5">Action</Typography>,
    sort: false,
    width: "5%",
    align: "center",
    mobileView: false,
  },
];

const tableHeadCellsLegacy = [
  {
    id: "First_Name",
    numeric: false,
    wrapCell: true,
    width: "21%",
    disablePadding: false,
    label: <Typography variant="h5">Employee</Typography>,
  },
  {
    id: "Company",
    numeric: false,
    disablePadding: false,
    sort: false,
    width: "12%",
    label: <Typography variant="h5">Company</Typography>,
  },
  {
    id: "Country",
    sort: false,
    numeric: false,
    disablePadding: false,
    width: "11%",
    label: <Typography variant="h5">Country</Typography>,
  },
  {
    id: "Joining_Date",
    sort: false,
    numeric: false,
    disablePadding: false,
    width: "11%",
    label: <Typography variant="h5">Joining Date</Typography>,
  },
  {
    id: "Status",
    sort: false,
    numeric: false,
    disablePadding: false,
    width: "17%",
    label: <Typography variant="h5">Employement Status</Typography>,
  },
  {
    id: "Payroll_Status",
    sort: false,
    numeric: false,
    width: "23%",
    disablePadding: false,
    label: <Typography variant="h5">Salary Details</Typography>,
  },
  {
    id: "action",
    label: <Typography variant="h5">Action</Typography>,
    sort: false,
    width: "5%",
    align: "center",
    mobileView: false,
  },
];

const getTooltipContent = (inActiveEmployee) => (
  <>
    <p className="tooltip-text">Inactive since</p>
    <p className="tooltip-bold">{getFullMontDateYearFromDate(inActiveEmployee?.reasonDate)}</p>
    <p className="mt-1 tooltip-text">Reason for marking Inactive</p>
    <p className="tooltip-bold">{inActiveEmployee?.reason}</p>
    <p className="mt-1 tooltip-text">Additional comments</p>
    <p className="tooltip-bold">{inActiveEmployee?.comments || "N/A"}</p>
  </>
);

function EmploymentStatus(status, inActiveEmployee, capturingReasonsForInactiveEmployees) {
  switch (status) {
    case "Assigned":
      return <ChipComp label={status} color="primary" />;
    case "Unassigned":
      return <ChipComp label={status} color="error" />;
    case "Pending":
      return <ChipComp label={status} color="warning" />;
    case "Inactive":
      return inActiveEmployee && capturingReasonsForInactiveEmployees ? (
        <div className="tooltip-wrapper">
          <CustomTooltip content={getTooltipContent(inActiveEmployee)} direction="right">
            <div className="inactive-chip-wrapper">
              <ChipComp label={status} color="default" startIcon={<InfoOutlinedIcon />} />
            </div>
          </CustomTooltip>
        </div>
      ) : (
        <ChipComp label={status} color="default" startIcon={<InfoOutlinedIcon />} />
      );
    default:
      return <ChipComp label={status} />;
  }
}

function EmploymentPayrollStatus(status) {
  switch (status) {
    case "Complete":
      return <ChipComp label={status} color="success" />;
    case "Cost to Customer Missing":
      return <ChipComp label={status} color="warning" />;
    case "Gross Pay Missing":
      return <ChipComp label={status} color="warning" />;
    case "Not Applicable":
      return <ChipComp label={status} color="default" />;
    case "Incomplete":
      return (
        <div className="flex items-center space-x-1">
          <ChipComp label="Cost to Customer Missing" color="warning" />
          <ChipComp label="Gross Pay Missing" color="warning" />
        </div>
      );
    default:
      return <ChipComp label={status} />;
  }
}

const getEmployeeStatusTooltipContent = (status = "", startDate = "", endDate = "") => {
  return (
    <>
      {startDate && (
        <p>
          <span className="para-body-s-regular">Start:</span>{" "}
          <span className="para-body-s-medium">{convertDate(startDate)}</span>
        </p>
      )}
      {status !== "Permanent" && endDate && (
        <p>
          <span className="para-body-s-regular">End:</span>{" "}
          <span className="para-body-s-medium">{convertDate(endDate)}</span>
        </p>
      )}
    </>
  );
};

function getEmployeeStatusChip(employee) {
  const { status, startDate = "", endDate } = employee || {};

  if (!status) return "_";

  const tooltipContent = getEmployeeStatusTooltipContent(status, startDate, endDate);
  const normalizedStatus = status.toLowerCase().replace(UNDERSCORE_GLOBAL, "-");

  return (
    <ChipComp
      size="small"
      {...getChipProps(status)}
      startIcon={
        <CustomTooltip content={tooltipContent} direction="bottom">
          <InfoOutlinedIcon className={`status-icon ${normalizedStatus}`} />
        </CustomTooltip>
      }
    />
  );
}

function AdminWorkForce() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const openFilterMenu = useRef(null);

  const { anniversaryBasedTimeOff } = useFlags();

  const searchParams = new URLSearchParams(location.search);
  const statusFromUrl = searchParams.get("status");

  const { softDeletion, capturingReasonsForInactiveEmployees } = useFlags();

  const [open, setOpen] = useState(false);
  const [tableRows, setTableRows] = useState([]);
  const [selectedRowID, setSelectedRowID] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [resetPage, setResetPage] = useState(false);
  const [page, setPage] = useState(0);
  const [DropdownData_, setDropdownData_] = useState({});
  const [apiFilters, setApiFilters] = useState({});
  const [sortBy, setSortBy] = useState({});
  const [selectedOptions, setSelectedOptions] = useState({});
  const [navigateToPage] = useState(null);
  const [searchEmployee, setSearchEmployee] = useState("");
  const [searchCustomerTimer, setSearchCustomerTimer] = useState(null);

  const rotate = open ? "rotate(180deg)" : "rotate(0)";

  const { employeesList, loadingGetEmployeesList } = useSelector((state) => state.GetEmployeeList || {});

  const { getEmployeeDetails, loadingGET_EMPLOYEE_Details } = useSelector((state) => state.GetEmployeeDetails || {});

  const { deleteUser, loadingDeleteUser } = useSelector((state) => state.DeleteUser || {});

  const getCustomerList = useSelector((state) => state.GetCustomerList?.getCustomerList);

  const closeOpenMenus = (e) => {
    if (
      openFilterMenu.current &&
      open &&
      !openFilterMenu.current.contains(e.target) &&
      !document.getElementsByClassName("MuiAutocomplete-popper").length
    ) {
      setOpen(false);
    }
  };

  document.addEventListener("mousedown", closeOpenMenus);

  const handleClick = () => {
    setOpen(!open);
  };

  const handleDelete = (event, key, option) => {
    event.preventDefault();
    setPage(() => 0);
    setOpen(false);
    if (selectedOptions[key]) {
      const newdict = { ...selectedOptions };
      newdict[key] = selectedOptions[key].filter((selectedOption) => selectedOption !== option);
      filterRemoved = true;

      if (!newdict[key].length && key == "customers") {
        dispatch(ResetGetCustomersList({}));
      }
      setSelectedOptions(newdict);
    }
  };

  const callbackFromMultiSelect = (option, key) => {
    selectedOptions[key] = option;
    setResetPage(true);
    setPage(() => 0);
    setSelectedOptions({
      ...selectedOptions,
    });

    if (!Object.keys(option).length && key == "customers") {
      dispatch(ResetGetCustomersList({}));
    }
  };

  const handleRowsPerPage = (pagination) => {
    setRowsPerPage(pagination.rowsPerPage);
    setPage(pagination.page);
  };

  const handleSelectedRow = (selectedEmployeeID) => {
    let loggedInUser = {};
    loggedInUser = JSON.parse(localStorage.getItem("loggedInUser"));
    dispatch(ResetGetEmployeeDetails({}));
    dispatch(ResetAddEmployeeSalaryData({}));
    dispatch(ResetAddEmployeeSalary({}));
    dispatch(ResetCalculateEmployeeSalary({}));
    if (Object.keys(loggedInUser).length && loggedInUser.userId != undefined && selectedEmployeeID) {
      dispatch(
        GetEmployeeDetails({
          customerID: loggedInUser?.userId,
          employeeID: selectedEmployeeID,
          request: `employee/${selectedEmployeeID}`,
        })
      );

      setSelectedRowID(selectedEmployeeID);
      navigate(`/main/details/${selectedEmployeeID}`);
    }
  };

  const getEmployeeListHandler = () => {
    dispatch(
      GetEmployeeList({
        rowsPerPage,
        searchEmployee,
        page,
        sortBy: {
          field: sortBy.orderBy,
          direction: sortBy.order,
        },
        dist: apiFilters,
      })
    );
  };

  const handleDeleteRow = async (selectedEmployeeId) => {
    let loggedInUser = {};
    let deleteUserRequest = "";
    loggedInUser = JSON.parse(localStorage.getItem("loggedInUser"));
    if (selectedEmployeeId != undefined && selectedEmployeeId != null) {
      if (loggedInUser?.type == "edge") {
        deleteUserRequest = `employee/${selectedEmployeeId}`;
      }
      if (softDeletion) {
        try {
          const response = await getRequest(`${baseUrl}/employee/${selectedEmployeeId}/deactivate`, true);
          getEmployeeListHandler();
          return response;
        } catch (error) {
          console.error("Failed to Deactivate Employee:", error);
          throw error;
        }
      } else {
        dispatch(
          DeleteUser({
            request: deleteUserRequest,
          })
        );
      }
    }
    return "";
  };

  const handleRequestSortBy = (request) => {
    setSortBy(request);
    dispatch(
      GetEmployeeList({
        rowsPerPage,
        searchEmployee,
        page,
        sortBy: {
          field: request.orderBy,
          direction: request.order,
        },
        dist: apiFilters,
      })
    );
  };

  const searchCustomer = (customerName) => {
    clearTimeout(searchCustomerTimer);
    const newTimer = setTimeout(() => {
      if (customerName.length >= 3) {
        dispatch(
          GetCustomersList({
            customerName,
            loaderFlag: false,
          })
        );
      } else {
        dispatch(ResetGetCustomersList({}));
      }
    }, 500);

    setSearchCustomerTimer(newTimer);
  };

  const handleReset = () => {
    setOpen(false);
    setSelectedOptions({ countries: [], customers: [], status: [] });
    setResetPage(true);
    setPage(0);
    setSearchEmployee("");
    filterRemoved = true;
    dispatch(ResetGetCustomersList({}));
  };

  const fetchNewEmpList = () => {
    dispatch(
      GetEmployeeList({
        rowsPerPage: 10,
        page: 0,
        dist: {},
        sortBy: {},
      })
    );
  };

  const handleSearchEmployee = (event) => {
    setSearchEmployee(event.target.value);
    setResetPage(true);
    setApiFilters({
      ...apiFilters,
      name: event.target.value,
    });
    setPage(0);
  };

  const handleExport = async () => {
    const name = searchEmployee || "";
    const response = await getRequest(
      `${baseUrl}/employees/export?${new URLSearchParams({
        limit: rowsPerPage,
        export: true,
        page,
        orderBy: JSON.stringify({
          field: sortBy?.field,
          direction: sortBy?.direction,
        }),
        filter: JSON.stringify({
          name: [name],
          country: apiFilters?.countries,
          company: apiFilters?.customers,
          status: apiFilters?.status,
        }),
      })}`,
      true,
      "export"
    );

    if (!response?.ok) {
      return;
    }
    const url = window.URL.createObjectURL(response?.payload);
    const link = document.createElement("a");
    link.style.display = "none";
    link.href = url;

    link.download = "Employees";
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(url);
  };

  useEffect(() => {
    const apiFilter = {};

    if (Object.keys(selectedOptions).length > 0) {
      Object.keys(selectedOptions).forEach((header) => {
        const arr = selectedOptions[header].map((option) => option.key);
        apiFilter[header] = arr;
      });

      setApiFilters(apiFilter);

      dispatch(
        GetEmployeeList({
          rowsPerPage,
          searchEmployee,
          page,
          dist: apiFilter,
          sortBy: {
            field: sortBy.orderBy,
            direction: sortBy.order,
          },
        })
      );
    } else if (filterRemoved) {
      dispatch(
        GetEmployeeList({
          rowsPerPage,
          searchEmployee,
          page,
          dist: null,
          sortBy: {
            field: sortBy.orderBy,
            direction: sortBy.order,
          },
        })
      );
    }
  }, [selectedOptions, rowsPerPage, page, searchEmployee, filterRemoved, sortBy, dispatch]);
  useEffect(() => {
    if (getEmployeeDetails?.ok) {
      if (navigateToPage) {
        if (selectedRowID && navigateToPage == "details") {
          navigate(`/main/details/${selectedRowID}`);
        } else if (navigateToPage == "addEmployee") {
          navigate("/main/addEmployee", {
            state: {
              navigatedFor: "editEmployee",
              redirectTo: "workforce",
              editEmployeeId: selectedRowID,
            },
          });
        }
      }
    }
  }, [getEmployeeDetails]);

  useEffect(() => {
    const Data = [];

    if (employeesList && Object.keys(employeesList).length) {
      employeesList?.rows?.forEach((employee) => {
        const rowData = {
          id: employee.employeeId,
          First_Name: (
            <div className="flex items-center">
              <CustomAvatar
                variant="circular"
                size="lg"
                src={`${baseUrl}/employee/${employee?.employeeId}/logo?id=${employee?.pictureVersion}&variant=thumbnail`}
                sx={{
                  marginRight: "8px",
                  bgcolor: "#C8C8C8",
                }}
              />
              <div>
                <p className="title-small">{`${getValue(employee.firstName)} ${getValue(employee.lastName)}`}</p>
                <p className="table-email">{getValue(employee.email)}</p>
              </div>
            </div>
          ),
          Company: <p className="title-small">{getValue(employee.companyName)}</p>,
          Country: <p className="title-small">{getValue(employee.country)}</p>,
          Joining_Date: <p className="title-small">{convertDate(employee?.startDate)}</p>,
          Status: EmploymentStatus(getValue(employee.status), employee?.reason, capturingReasonsForInactiveEmployees),
          Payroll_Status: EmploymentPayrollStatus(getValue(employee.payrollStatus)),
          action: (
            <div className="flex items-center space-x-1">
              <EditEmployee
                selectedId={employee.employeeId}
                handleSelectedRow={handleSelectedRow}
                navigateTo="details"
              />
              <DeleteEmployee
                selectedId={employee.employeeId}
                status={employee?.status}
                handleDeleteRow={handleDeleteRow}
                title="Employee"
                employeeFullName={`${getValue(employee.firstName)} ${getValue(employee.lastName)}`}
                getEmployeeListHandler={getEmployeeListHandler}
                scheduledAction={employee?.scheduledAction}
              />
            </div>
          ),
        };

        if (anniversaryBasedTimeOff) {
          const { employeeStatusDetails } = employee || {};
          rowData.Employee_Status = <p className="title-small">{getEmployeeStatusChip(employeeStatusDetails)}</p>;
        }

        Data.push(rowData);
      });

      setTableRows(Data);
    }
  }, [employeesList]);

  useEffect(() => {
    let loggedInUser = {};
    loggedInUser = JSON.parse(localStorage.getItem("loggedInUser"));
    if (deleteUser && Object.keys(deleteUser).length && deleteUser?.ok && deleteUser?.payload) {
      if (Object.keys(loggedInUser).length && loggedInUser.userId && loggedInUser?.type === "edge") {
        dispatch(
          GetEmployeeList({
            rowsPerPage,
            searchEmployee,
            page,
            sortBy: {
              field: sortBy.orderBy,
              direction: sortBy.order,
            },
            dist: apiFilters,
          })
        );
      }
      dispatch(ResetDeleteUser({}));
    }
  }, [deleteUser]);

  useEffect(() => {
    const customers = [];

    if (getCustomerList?.ok) {
      getCustomerList?.payload?.map((data) => {
        customers.push({
          key: data.companyName,
          value: data.companyName,
        });
      });
    }
    setDropdownData_({
      ...DropdownData_,
      customers,
    });
  }, [getCustomerList]);

  useEffect(() => {
    const countries = [];
    const statusOption = [];
    const customers = [];
    const salaryStatus = [];
    const employeeEngagementStatus = [];
    let dropdownData = {};
    dropdownData = JSON.parse(sessionStorage.getItem("dropdownData"));

    dispatch(ResetDeleteUser({}));
    dispatch(ResetAddEmployee({}));
    dispatch(ResetCalculateEmployeeSalary({}));
    dispatch(ResetAddEmployeeSalaryData({}));
    dispatch(ResetAddEmployeeSalary({}));
    dispatch(ResetEducationInfo({}));

    if (dropdownData && Object.keys(dropdownData).length && dropdownData.ok) {
      dropdownData?.payload?.country?.map((data) => {
        countries.push({
          key: data.countryCode,
          value: data.countryCode,
        });
      });

      dropdownData?.payload?.employeeStatus?.map((data) => {
        statusOption.push({
          key: data.value,
          value: data.label,
        });
      });
      dropdownData?.payload?.salaryStatus?.map((data) => {
        salaryStatus.push({
          key: data?.value,
          value: data?.label,
        });
      });
      dropdownData?.payload?.employeeEngagementStatus?.map(({ value, label }) => {
        employeeEngagementStatus.push({
          key: value,
          value: label,
        });
      });
    }
    const statusOptionsFromUrl =
      statusFromUrl === "active"
        ? statusOption.filter((item) => item.key !== "inactive")
        : statusOption.filter((item) => item.key === statusFromUrl);

    setSelectedOptions({
      status: statusFromUrl ? statusOptionsFromUrl : statusOption.filter((item) => item.key !== "inactive"),
    });

    setDropdownData_({
      ...DropdownData_,
      status: statusOption,
      customers,
      countries,
      salaryStatus,
      employeeEngagementStatus,
    });
    return () => {
      dispatch(ResetGetEmployeeList({}));
    };
  }, []);

  return (
    <>
      {loadingDeleteUser || loadingGET_EMPLOYEE_Details || loadingGetEmployeesList ? <PageLoader /> : null}
      <Grid container direction="column" rowSpacing={3}>
        <FileUpload onUploadSuccess={fetchNewEmpList} />
        <Grid item>
          <Grid
            item
            container
            direction="row"
            justifyContent="flex-end"
            columnSpacing={3}
            style={{
              left: "-80px",
              marginTop: "-10px",
            }}
          >
            <Grid item>
              {Object.keys(selectedOptions).map((key) => {
                return selectedOptions[key].map((option) => {
                  return (
                    <Chip
                      key={option.key}
                      label={<Typography variant="h6">{option.value}</Typography>}
                      clickable
                      sx={{
                        bgcolor: "#D3E0F4",
                        mx: 0.5,
                        height: 26,
                        borderRadius: "10px",
                        color: "#1161D5",
                        "& .MuiChip-deleteIcon": {
                          color: "#3C7DDC",
                          fontSize: "1.0rem",
                        },
                      }}
                      onDelete={(e) => handleDelete(e, key, option)}
                    />
                  );
                });
              })}
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <DataTable
            rowsData={tableRows}
            resetPage={resetPage}
            selectedOptions={apiFilters}
            totalCount={employeesList?.count ? employeesList.count : 0}
            tableheadCells={anniversaryBasedTimeOff ? tableheadCellsRevamped : tableHeadCellsLegacy}
            title={`Your Employees (${employeesList?.count ? employeesList.count : 0})`}
            titleIcon={totalEmployeesIcon}
            subTitle={null}
            toolBar
            slectedRowNavigation="/main/details"
            sortByName="First_Name"
            openDetailsPage="First_Name"
            handleRowsPerPage={handleRowsPerPage}
            handleSelectedRow={handleSelectedRow}
            handleRequestSortBy={handleRequestSortBy}
            exportButton={
              <Button
                disableElevation
                variant="contained"
                fullWidth
                sx={{
                  width: "140px",
                  height: "35px",
                  borderRadius: "5px",
                  color: "white",
                }}
                onClick={handleExport}
              >
                <Typography id="export-emps" variant="h6" color="white">
                  Export
                </Typography>
              </Button>
            }
            filterButton={
              <Box id="filter-emps" sx={{ position: "relative" }} ref={openFilterMenu}>
                <FilterListIcon
                  onClick={handleClick}
                  style={{
                    transform: rotate,
                    transition: "all 0.2s linear",
                  }}
                />
                <Grow
                  in={open}
                  style={{
                    transformOrigin: "right 0 0 ",
                  }}
                  {...(open ? { timeout: 350 } : {})}
                  unmountOnExit
                >
                  <Paper elevation={3} sx={styles}>
                    <Filter
                      searchCustomer={searchCustomer}
                      data={DropdownData_}
                      selectedOptions={selectedOptions}
                      handleReset={handleReset}
                      callbackFromMultiSelect={callbackFromMultiSelect}
                    />
                  </Paper>
                </Grow>
              </Box>
            }
            SearchEmployee={
              <TextField
                id="search-emp"
                sx={{
                  "&.MuiTextField-root": {
                    marginTop: 0,
                  },
                  "& .MuiInputBase-root": {
                    backgroundColor: "white",
                    borderRadius: "5px",
                    fontFamily: "Poppins-Medium !important",
                    height: "38px",
                  },
                  "& .MuiInputBase-input": {},
                }}
                variant="outlined"
                placeholder="Enter Employee Name"
                size="small"
                name="email"
                value={searchEmployee}
                fullWidth
                onChange={handleSearchEmployee}
                margin="normal"
                InputProps={{
                  disableUnderline: true,
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon
                        sx={{
                          mx: 1,
                        }}
                      />
                    </InputAdornment>
                  ),
                }}
              />
            }
            AddNewRowButton={
              <Button
                disableElevation
                variant="contained"
                id="addEmployee"
                key="addEmployee"
                fullWidth
                sx={{
                  width: "140px",
                  height: "35px",
                  borderRadius: "5px",
                  color: "white",
                }}
                onClick={() => {
                  dispatch(ResetAddEmployeeSalaryData({}));
                  dispatch(ResetAddEmployeeSalary({}));
                  dispatch(ResetemployeeSalaryInfo({}));
                  navigate("/main/addEmployee", {
                    state: {
                      navigatedFor: "addEmployee",
                      redirectTo: "workforce",
                    },
                  });
                }}
              >
                <Typography variant="h6" color="white">
                  Add Employee
                </Typography>
              </Button>
            }
          />
        </Grid>
      </Grid>
    </>
  );
}

export default AdminWorkForce;
